import { useState, useEffect } from 'react';
import { useParams } from "react-router";
import { v4 as uuid } from 'uuid'
import GlobalLayout from './GlobalLayout';
import { getPageByID } from '../services/front_api';
import ChartBuilder from '../components/charts/ChartBuilder';
import GridBuilder from '../components/grids/GridBuilder';

// const demoLayout = `{
//   "rows": [
//     {
//       "cols": [
//         {
//           "tag": "block1",
//           "style": { "border": "1px solid #0000FF", "padding": "10px" }
//         },
//         {
//           "tag": "block2",
//           "colspan": 2
//         }
//       ]
//     },
//     {
//       "cols": [
//         {
//           "tag": "block3"
//         },
//         {
//           "tag": "block4",
//           "rowspan": 2
//         },
//         {
//           "tag": "block5"
//         }
//       ]
//     },
//     {
//       "cols": [
//         {
//           "tag": "block6"
//         },
//         {
//           "tag": "block7",
//           "style": { "border": "1px solid #00FF00", "padding": "10px" }
//         }
//       ]
//     }
//   ]
// }`;

// const demoContent = `{
//   "content": [
//     {
//       "type": "chart",
//       "view": "bar",
//       "query": "toto",
//       "params": {
//         "title": "Titre du graphique"
//       }
//     },
//     {
//       "type": "chart",
//       "view": "line",
//       "query": "titi",
//       "params": {
//         "title": "Titre du graphique"
//       }
//     },
//     {
//       "type": "chart",
//       "query": "tata"
//     },
//     {
//       "type": "chart",
//       "query": "tutu"
//     },
//     {
//       "type": "chart",
//       "query": "tete"
//     },
//     {
//       "type": "chart",
//       "query": "trtr"
//     },
//     {
//       "type": "chart",
//       "query": "tyty"
//     }
//   ]
// }`;


function renderComponent(key, index, block, content) {
	var style = {
		padding: "10px",
		borderRadius: "8px",
		border: "1px solid rgba(0,0,0,0.08)",
		boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
		background: "var(--bg-content)",
	};

	if (block.style) {
		style = { ...style, ...block.style };
	}
	if (block.colspan) {
		style.gridColumn = "span " + block.colspan + " / span " + block.colspan;
	}
	if (block.rowspan) {
		style.gridRow = "span " + block.rowspan + " / span " + block.rowspan;
	}

	// TODO: Call API : Query infos (app + type)
	switch (content[index].type) {
		case "chart":
			return (
				<div key={key} className={block.class} style={style}>
					<ChartBuilder view={content[index].view} query={content[index].queryName} params={content[index].params} />
				</div>
			);
		case "indic":
			return (
				<div key={key} className={block.class} style={style}>
					<ChartBuilder view={content[index].view || "indic"} query={content[index].queryName} params={content[index].params} category="indic" />
				</div>
			);
		case "grid":
			return (
				<div key={key} className={block.class} style={style}>
					<GridBuilder view={content[index].view} query={content[index].queryName} queryId={content[index].queryId} params={content[index].params} />
				</div>
			);
		default:
			return null;
	}
}

function findLayoutSize(data) {
	let nbRows = 0;
	let nbCols = 0;

	if (data && data.rows) {
		nbRows = data.rows.length;
		data.rows.forEach(row => {
			if (row.cols && row.cols.length > nbCols) {
				nbCols = row.cols.length;
			}
		});
	}

	return { nbRows, nbCols };
}

const DynamicChartLayout = (props) => {
	const [pageID, setPageID] = useState(null);
	const [pageData, setPageData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [isModalOpen, setModalOpen] = useState(false);
	const [activeApp, setActiveApp] = useState(localStorage.getItem('active_app') || '');

	let { id } = useParams();

	if (id != null && id !== pageID) {
		setPageID(id);
	}

	const handleOpenModal = (e) => {
		setModalOpen(true);
	};

	const handleCloseModal = () => {
		setModalOpen(false);
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await getPageByID(pageID);
				if (!data.contents) {
					setError(new Error('Page not found'));
					return;
				}
				setPageData(data);
				setError(null);

				const app = localStorage.getItem('active_app');
				setActiveApp(app);
			} catch (err) {
				setError(err);
			} finally {
				setLoading(false);
			}
		};

		fetchData();

	}, [pageID]);

	if (loading) return <div>Chargement...</div>;

	var DBLayout, layoutSize;
	if (!error) {
		DBLayout = JSON.parse(pageData.layout);
		layoutSize = findLayoutSize(DBLayout);
	}

	let counter = -1;
	return (
		<GlobalLayout>
			{error
				? <div style={{ color: 'red' }}>Erreur : {error.message}</div>
				: <div key={uuid()} className="content" style={{ height: "100%", display: "grid", gridTemplateColumns: `repeat(${layoutSize.nbCols}, 1fr)`, gridTemplateRows: `repeat(${layoutSize.nbRows}, 1fr)`, gap: "8px" }}>
					{DBLayout.rows.map((row, indexLine) => {
						return (
							<>
								{row.cols.map((block, indexBlock) => {
									counter++;
									return renderComponent(uuid(), counter, block, pageData.contents.content);
								})}
							</>
						);
					})}
				</div >
			}
		</GlobalLayout>
	)
}

export default DynamicChartLayout;
